__turbopack_context__.v({
  "className": "karla_c6fd5f2c-module__WUSLpq__className",
  "variable": "karla_c6fd5f2c-module__WUSLpq__variable",
});
